import React, { useMemo } from "react";
import { KenloPropertyOption } from "../utils/getKenloPropertyOptions";
import DashboardSelect from "./DashboardSelect";

interface KenloPropertyFilterProps {
  properties: KenloPropertyOption[];
  selectedKenloPropertyId: string | null;
  onSelectProperty: (kenloPropertyId: string | null) => void;
  label?: string;
}

export default function KenloPropertyFilter({
  properties,
  selectedKenloPropertyId,
  onSelectProperty,
  label = "Imóvel",
}: KenloPropertyFilterProps) {
  const options = useMemo(
    () => [
      { value: "all", label: "Todos os imóveis" },
      ...properties.map((property) => ({
        value: property.kenloPropertyId,
        label: property.label,
      })),
    ],
    [properties]
  );

  if (properties.length === 0) {
    return null;
  }

  return (
    <div className="w-full sm:min-w-[200px]">
      <DashboardSelect
        label={label}
        value={selectedKenloPropertyId ?? "all"}
        options={options}
        onChange={(value) => onSelectProperty(value === "all" ? null : value)}
      />
    </div>
  );
}
